import { combineReducers } from 'redux';

import tickets from './reducers/my-tickets';
import costItems from './reducers/cost-items';
import ui from './reducers/ui';
import pagination from './reducers/pagination';
import passes from './reducers/passes';

const rootReducer = combineReducers({
  tickets,
  costItems,
  ui,
  pagination,
  passes
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/my-tickets/reducer.js